
import SourceItem from './source-item.vue'

export default {
  components: {SourceItem},
  props: {
    sources: {
      type: Array,
      required: true
    }
  },
  computed: {
    size() {
      return `min(${this.sources.length > 1 ? '92.1rem' : '46rem'}, 90%)`
    },
  },
  methods: {
    open(){
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
  }
}
